// Demo mode: bypass Cognito and auto-authenticate
const DEMO_USER = {
  token: 'demo-token',
  accessToken: 'demo-access-token',
  user: {
    username: 'admin',
    email: 'admin@demo.com',
    name: 'admin',
    role: 'PlantDirector',
  },
};

const authService = {
  login: async () => {
    return DEMO_USER;
  },

  logout: async () => {
    return Promise.resolve();
  },

  getCurrentUser: async () => {
    return DEMO_USER;
  },

  getIdToken: async () => {
    return DEMO_USER.token;
  },
};

export default authService;
